import * as types from "./mutation_types";

export default {
  [types.CARTE_UPDATE_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.CARTE_UPDATE_TOGGLE_LOADING](state) {
    Object.assign(state, { error: "", isLoading: !state.isLoading });
  },

  [types.CARTE_UPDATE_SET_UPDATED](state, created) {
    Object.assign(state, { created });
  },

  [types.CARTE_UPDATE_RESET](state) {
    Object.assign(state, {
      created: false,
      error: "",
      isLoading: false,
    });
  },
};
